import React from 'react';
import { Pagination } from 'antd';

import { useArchivesPageManager } from '../../../../contexts/ArchivesPageManager/Provider';

export default function CustomPagination() {
  const { totalItems, pagination, setPagination } = useArchivesPageManager();

  const onChange = (newPage, newPageSize) => {
    setPagination({ page: newPage, limit: newPageSize });
  };

  return (
    <Pagination
      total={totalItems}
      defaultCurrent={pagination.page}
      defaultPageSize={pagination.limit}
      onChange={onChange}
      showSizeChanger
      showQuickJumper
      showTotal={(total) => `Total de ${total} acervos`}
      style={{ marginTop: '8px' }}
    />
  );
}
